<mat-chip [class]="getStatusColour()" class="full-width" highlighted id="status-chip">
  {{ status }}
</mat-chip>
